module.exports = __webpack_public_path__ + "static/img/logoFour.d65d7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree/logoFour.png
// module id = e/xc
// module chunks = 0